import App_data from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';
import PostData from '../../../RestAPI/fetchData';

const fetchNotes = async (data) => {
  return await GetData.callAPI(`${App_data.backend_api}/exams/frm/notes/all-notes`, data);
};
const fetchSavedQuestion = async (data) => {
  return await PostData.callAPI(`${App_data.backend_api}/frm_notes/getFavNotes`, data);
};
const deleteSavedQuestion = async (data) => {
  return await PostData.callAPI(`${App_data.backend_api}/frm_notes/unsaveFavNotesByUserID`, data);
};
const saveQuestion = async (data) => {
  return await PostData.callAPI(`${App_data.backend_api}/frm_notes/saveFavNotesByUserID`, data);
};
const fetchNotesStats = async (data) => {
  return await PostData.callAPI(`${App_data.backend_api}/frm_notes/getsavestatesNotes`, {
    question_id: data.id,
    level: data.level,
  });
};
const saveNotesStats = async (data) => {
  return await PostData.callAPI(`${App_data.backend_api}/frm_notes/saveNotesstats`, {
    notes_id: data.id,
    level: data.level,
    frmLevel: data.level,
  });
};
const reportQuestion = async (data) => {
  return await PostData.callAPI(`${App_data.backend_api}/frm_notes/reportQuestion`, data);
};
module.exports = {
  fetchNotes,
  fetchSavedQuestion,
  deleteSavedQuestion,
  saveQuestion,
  fetchNotesStats,
  saveNotesStats,
  reportQuestion,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/View/ApiService.js